import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateEventSettingPayload } from '@app-store/slices/eventSettings/create'

interface TaskAction extends Action {
    payload: ICreateEventSettingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.create

function* createEventSettingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/event/settings`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createEventSettingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createEventSettingSagaTask)
}

export default createEventSettingSaga
